module.exports = {
  DEBUG: true,
  APP_ENV: 'development',
  API_URL: 'http://localhost:63509/api',
  BLADE_API_KEY: '6506042A-FB33-4A08-9D4D-7006B0BE19DD'
  // more env vars here
}



// WEBPACK FOOTER //
// ./src/env/development.js